import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

import styles from '../PlanCard.module.scss';
import { ITariffCostProps as IProps } from '../types';

export const TariffCost: React.FC<IProps> = ({
  isYearly,
  tariffDataYearly,
  tariffDataMonthly,
  isFree,
  tariffAnnualMonthlyCrossed,
  tariffMonthlyCrossed,
}) => {
  const { t } = useTranslation();

  const tariffPrice = isYearly ? t(tariffDataYearly.tariffCostMonthly) : t(tariffDataMonthly.tariffCostMonthly);
  const crossedText = !tariffMonthlyCrossed ? null : isYearly ? tariffAnnualMonthlyCrossed : tariffMonthlyCrossed;
  const tariffText = isYearly
    ? t('billedAnnuallyShort', { price: tariffDataYearly.tariffCostYearly })
    : t('billedAnnuallyShort', { price: tariffDataMonthly.tariffCostYearly });

  return (
    <Box className={styles.tariffCostWrapper}>
      <Box className={styles.tariffCostPriceWrapper}>
        {crossedText && <Typography className={styles.crossedPrice}>{crossedText}</Typography>}

        <Typography className={styles.price}>{tariffPrice}</Typography>
        <Typography variant="body2">{' ' + `/ ${t('perMonth')}`} </Typography>
      </Box>
      {isYearly && (
        <Typography variant="body2" className={clsx({ [styles.tariffCostTextHidden]: isFree })}>
          {tariffText}
        </Typography>
      )}
    </Box>
  );
};
